import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import home from '../../assets/home.png';
class LegalNotice extends Component{

    constructor(props) {
        super(props);
        this.state={
            windowheight: 0
        };
    } 
    componentDidMount() {
        window.scrollTo(0, 0);
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
      }
      componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
      updateWindowDimensions = () => {
        this.setState({ windowheight: window.innerHeight - this.Dimension("headercontent") - this.Dimension("footercontent") });
      }
      Dimension = (elmID) => {
        var elmHeight, elmMargin, elm = document.getElementsByClassName(elmID)[0];
        if (document.all) {// IE
          elmHeight = elm.clientHeight;
          elmMargin = parseInt(elm.currentStyle.marginTop, 10) + parseInt(elm.currentStyle.marginBottom, 10);
        } else {// Mozilla
          elmHeight = elm.clientHeight;
          elmMargin = parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-top')) + parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-bottom'));
        }
        return (elmHeight + elmMargin + 6);
      }
    render(){
        return(
            <div className="contentbody">
                <div className='some-page-wrapper' style={{ minHeight: + this.state.windowheight }}>
                    <div className="legalContent"> 
                    <h2 style={{display:"inline"}}><b>Legal Notice</b></h2>   
                    <Link to="/"><img className="homeicon" src={home} /></Link>
                        <p>All content of this intranet site is owned or controlled by Johnson & Johnson Services, Inc. and is protected by worldwide copyright laws. You may download content only for your personal use for non-commercial purposes but no modification or further reproduction of the content is permitted. The content may otherwise not be copied or used in any way.</p>
                        <p>
                        The owners of this site will use reasonable efforts to include up-to-date and accurate information in this intranet site, but makes no representations, warranties, or assurances as to the accuracy, currency, or completeness of the information provided. The owners of this site shall not be liable for any damages or injury resulting from your access to, or inability to access, this intranet site, or from your reliance on any information provided at this intranet site.
                        </p>
                        <p>
                        This intranet site may provide links or references to other sites but the owners of this site have no responsibility for the content of such other sites and shall not be liable for any damages or injury arising from that content. Any links to other sites are provided as merely a convenience to the users of this intranet site.
                        </p>
                        <p>
                        The trademarks, service marks, trade names, trade dress and products in this intranet site are protected in the United States and internationally. No use of any of these may be made without the prior, written authorization of the owners of this site, except to identify the products or services of the company.
                        </p>
                        <p>
                        Any personally identifiable information in electronic communications to this intranet site is governed by this site's <Link to="/PrivacyPolicy"><a href="#" style={{color: "black"}}>Privacy Policy</a></Link>.The owners of this site shall be free to use or copy all other information in any such communications, including any ideas, inventions, concepts, techniques or know-how disclosed therein, for any purposes. Such purposes may include disclosure to third parties and/or developing, manufacturing and/or marketing goods or services.
                        </p>
                        <p>
                        The sender of any communications to this intranet site or otherwise to the owners of this site shall be responsible for the content and information contained therein, including its truthfulness and accuracy.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}
export default LegalNotice;

